module.exports = __webpack_public_path__ + "static/img/24.b7ae69c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/24.png
// module id = VXZX
// module chunks = 0